import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api, { createApi } from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import MessageEditModal from "../MessageEditModal";
import ForwardMessageModal from "../ForwardMessageModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import { legendaMidia, nomeArquivoSalvo } from "../../helpers/legendaMidia";

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl, urlBackend, conOficial, whatsappId }) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [encaminharOpen, setEncaminharOpen] = useState(false);
  const apiCustom = createApi(urlBackend);

  const agora = Date.now();
  const tempoMensagem = new Date(message.dataMensagem).getTime();

  // Tipos em que a edição faz sentido: texto ("chat") e as mídias que têm legenda.
  // O mediaType da mídia vem do mimetype no backend, então documento cai em
  // "application" (pdf/docx/xlsx) ou "text" (txt/csv). Ficam de fora "audio" e
  // "vcard"/"location" (não têm legenda) e "internal_note"/"info_icode" (nunca
  // foram para o WhatsApp).
  const tiposEditaveis = ["chat", "image", "video", "application", "text"];

  // Figurinha também chega como mediaType "image" (image/webp) e não tem legenda.
  // Identificada pela extensão, igual o rotuloMidia do MessagesList faz.
  const ehFigurinha = (nomeArquivoSalvo(message) || "").toLowerCase().endsWith(".webp");

  // Balões que nunca foram para o WhatsApp: não há o que encaminhar.
  const tiposLocais = ["internal_note", "info_icode"];
  
  const podeEncaminhar = !message.isDeleted
    && !tiposLocais.includes(message.mediaType)
    && (!conOficial || (message.fromMe && message.mediaType === "chat"));

  const podeEditar = !conOficial && message.fromMe && tiposEditaveis.includes(message.mediaType) && !ehFigurinha && (agora - tempoMensagem) <= (15 * 60 * 1000);
  const podeApagar = !conOficial && message.fromMe && (agora - tempoMensagem) <= (60 * 60 * 60 * 1000);

  const handleDeleteMessage = async () => {
    try {
      await apiCustom.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenEncaminhar = () => {
    setEncaminharOpen(true);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleOpenEditModal = (e) => {
    try {
      setEditOpen(true);
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  // newMessage === null = cancelou (ou fechou clicando fora). Texto igual ao atual
  // também não vai: gastaria uma edição no WhatsApp sem mudar nada. A comparação
  // usa legendaMidia (e não message.body) porque em mídia sem legenda o body é o
  // nome do arquivo salvo, não a legenda.
  const handleEditModal = async (newMessage) => {
    if (newMessage === null || newMessage === legendaMidia(message)) {
      setEditOpen(false);
      handleClose();
      return;
    }
    try {
      await apiCustom.put(`/messages/${message.id}`, { newMessage });
      setEditOpen(false);
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <MessageEditModal
        modalOpen={editOpen}
        mensagem={message}
        onClose={handleEditModal}
      />
      <ForwardMessageModal
        open={encaminharOpen}
        onClose={() => setEncaminharOpen(false)}
        message={message}
        whatsappId={whatsappId}
        urlBackend={urlBackend}
      />
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {podeEditar && (
          <MenuItem onClick={handleOpenEditModal}>
            Editar
          </MenuItem>
        )}
        {podeApagar && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        {podeEncaminhar && (
          <MenuItem onClick={handleOpenEncaminhar}>
            {i18n.t("messageOptionsMenu.forward")}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
